import { combineReducers } from 'redux';

import {
  getOrganizationListRequest,
  getOrganizationListFail,
  getOrganizationListSuccess,
  setOrganizationListDirty,
  clearOrganizationList,
} from '../actions';
import { OrganizationAction } from '../types';
import { Loadable, Reducer } from '../../../types';
import { ItemList } from '../../../../types/main';
import { Organization } from '../../../../types/items';
import { stripItems } from '../../../../utility/store';

type State = Loadable<ItemList<Organization>>;
type ReducerOf<T extends keyof State> = Reducer<State, OrganizationAction, T>;

const data: ReducerOf<'data'> = (state = null, action) => {
  switch (action.type) {
    case getOrganizationListRequest.type:
      return state ? stripItems(state) : null;

    case getOrganizationListSuccess.type:
      return action.payload;

    case clearOrganizationList.type:
      return null;

    default:
      return state;
  }
};

const loading: ReducerOf<'loading'> = (state = false, action) => {
  switch (action.type) {
    case getOrganizationListRequest.type:
      return true;

    case getOrganizationListSuccess.type:
    case getOrganizationListFail.type:
      return false;

    default:
      return state;
  }
};

const dirty: ReducerOf<'dirty'> = (state = false, action) => {
  switch (action.type) {
    case setOrganizationListDirty.type:
      return action.payload;

    case getOrganizationListSuccess.type:
    case getOrganizationListFail.type:
      return false;

    default:
      return state;
  }
};

export default combineReducers<State>({
  data,
  loading,
  dirty,
});
